module.exports = __webpack_public_path__ + "img/more.6cbaf8de.png";